export function getCookie(name: AnyFixMe): string {
  const re = new RegExp(`(?:^|\\W)${name}\s*=([^;]*)`);
  const match = window.document.cookie.match(re);
  return match ? match[1].trim() : null;
}
